<b-container fluid="sm">
    <b-row align-v="center">
    <b-col cols="12">
                    <b-card type="secondary" shadow header-classes="bg-white">
                        <b-card-text>
                            <b-form enctype="multipart/form-data">
                                <legend>Passenger Details <span v-if="booking.passengerCount > 1 ">{{capturingForPassenger}}</span></legend>
                                <hr />
                                <b-row>
                                    <b-col>
                                        <b-form-group label="Title:" label-for="input-1">
                                            <b-form-select v-model='booking.title' placeholder="" :options="optionTitle">
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <b-form-group label="Name(s):">
                                            <b-form-input id="input-1" v-model="booking.name" placeholder="Name(s)">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <b-form-group label="Surname:">
                                            <b-form-input id="input-1" v-model="booking.surname" placeholder="Surname">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" md="6">
                                        <b-form-group label="Contact Number:">
                                            <b-form-input id="input-1" v-model="booking.contactNumber"
                                                placeholder="Contact Number"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <b-form-group label="Emergency Number:">
                                            <b-form-input id="input-1" v-model="booking.emergencyNumber"
                                                placeholder="Emergency Number"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" md="6">
                                        <b-form-group label="Traveling With Infact">
                                            <b-form-select v-model="booking.infant" :options="optionInfant">
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <div>
                                    <b-button type="button" @click='proceed' variant="primary" class="my-4">
                                        Proceed
                                    </b-button>
                                </div>
                            </b-form>
                        </b-card-text>
                    </b-card>
    </b-col>		
    </b-row>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
    </b-container>